/**
 * The handbook link in the app bar (spec §8.24) `[M23]`.
 *
 * It follows the reader: on a page it opens the page guide, in the graph the graph guide, and the
 * handbook's front page where nothing more specific fits — in their own interface language. It
 * reads the location itself, as a leaf, so changing route re-renders this link and not the shell.
 */
import { useLocation } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";
import { useI18n, useT } from "../i18n";
import { helpPageFor, helpUrl } from "../i18n/help";

export function HandbookLink() {
  const { language } = useI18n();
  const t = useT();
  const page = helpPageFor(useLocation().pathname);
  return (
    <a
      className="flex items-center gap-1.5 text-[13.5px] text-neutral-500 transition hover:text-neutral-900 dark:hover:text-neutral-100"
      href={helpUrl(page, language)}
      target="_blank"
      rel="noopener noreferrer"
      title={page ? t("app.help") : t("app.handbook")}
      data-testid="handbook-link"
      data-page={page || undefined}
    >
      <BookOpen size={15} aria-hidden="true" />
      {t("app.handbook")}
    </a>
  );
}
